import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import i18n from './plugins/i18n';
import router from "@/router";
import axios from 'axios';
import VueTypedJs from 'vue-typed-js'
import Carousel3d from 'vue-carousel-3d';
import './styles/site.scss';

Vue.use(VueTypedJs)
Vue.use(Carousel3d)

window.axios = require('axios');

axios.interceptors.request.use(function (config) {
  if (config.url.startsWith('https://web-admin.sum.ba')){
    config.headers.accept = "application/json";
    config.headers.language = localStorage.getItem('language') ? localStorage.getItem('language') : 'hr'
    // config.headers.language = localStorage.getItem('setLanguage');
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo, {
  container: "body",
  duration: 700,
  offset: -84,
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  i18n,
  render: h => h(App)
}).$mount('#app')
